import QuoteLeft from "../../assets/icons/QuoteLeft.webp";
import QuoteRight from "../../assets/icons/QuoteRight.webp";
import Star from "../../assets/icons/Star.webp";

import "./ReviewCard.css";

const ReviewCard = ({ data }) => {
	return (
		<div className="review-card" key={data["id"]}>
			<div className="review-card-top">
				<div className="review-card-icon">
					<img
						alt={data["alt"]}
						src={require("../../assets/" + data["image"])}
						className="review-card-icon-img"
					/>
				</div>
				<h4 className="h4-bold" style={{ margin: 0, textAlign: "center" }}>
					{data["name"]}
				</h4>
				<div className="review-card-stars">
					{[...Array(data["stars"])].map((i, index) => (
						<img
							key={index}
							alt={"star-" + index}
							src={Star}
							className="review-card-stars-img"
						/>
					))}
				</div>
			</div>
			<div className="review-card-bottom">
				<img
					alt={"quote-left-" + data["id"]}
					src={QuoteLeft}
					className="review-card-quote-left"
				/>
				<h5 className="review-card-description">{data["description"]}</h5>
				<img
					alt={"quote-right-" + data["id"]}
					src={QuoteRight}
					className="review-card-quote-right"
				/>
			</div>
		</div>
	);
};

export default ReviewCard;
